module.exports = __webpack_public_path__ + "static/media/redLogo.6a6eaf6c.svg";